// extracted by mini-css-extract-plugin
module.exports = {"text":"OpenButton_text__20_H7","contained":"OpenButton_contained__n1DpJ","disabled":"OpenButton_disabled__3zM4O","error":"OpenButton_error__1KfFq"};